<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" class="mb-0">
      <template v-slot:prepend>
        <v-icon icon="mdi-home" size="small"></v-icon>
      </template>
    </v-breadcrumbs>

    <v-container class="grey lighten-5">

    </v-container>

  </div>
</template>

<script>

export default {
  name: 'EventComponent',
  components: {

  },
  data: () => ({
    breadcrumbs: [
      {
        title: 'Dashboard',
        disabled: false,
        to: '/dashboard',
      },
      {
        title: 'Calender',
        disabled: false,
        to: '/calendar',
      },
      {
        title: 'Event',
        disabled: true,
        to: '',
      },
    ],
  }),

  mounted() {
  },

  methods: {
  }
}
</script>